import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['avatar', 'counter']

  connect() {
    this.setCounterVisibility()
  }

  setCounterVisibility() {
    const hiddenAvatars = Array.from(this.avatarTargets).filter(avatar => {
      return window.getComputedStyle(avatar).display === 'none'
    })

    if (hiddenAvatars.length === 0) {
      this.counterTarget.classList.add('hidden')
      return
    }

    this.counterTarget.classList.remove('hidden')
    this.counterTarget.textContent = `+${hiddenAvatars.length}`
  }
}
